export { Proportion } from './Proportion';
export type { ProportionProps } from './Proportion.types';
